export interface ForthLeafPermissionAccessInput {
  activePermissions: string[];
  requiredPermission: string;
}

export const hasForthLeafPermission = ({
  activePermissions,
  requiredPermission,
}: ForthLeafPermissionAccessInput) => activePermissions.includes(requiredPermission);
